export default {
	name(state) {
		return state.account.firstname + ' ' + state.account.lastname;
	},

	contextualizationTimelines(state) {
		return state.contextualization.timelines;
	},

	contextualizationPanel(state) {
		return state.contextualization.panel;
	},

	contextualizationPanelState(state) {
		return state.contextualization.panel.extended;
	},

	contextualizationPanelVisibility(state) {
		return state.contextualization.panel.visible;
	}
}